import "./ContactBtn.scss";

const ContactBtn = ( {setOpenModal }) => {
  return (

      <button className="open__modal" onClick={() => setOpenModal(true)}>
        Contact me
      </button>
  )
}

export default ContactBtn;


